// === Dispatched lifecycle events (interceptable via eventBus.dispatch) ===
// CurationMode consumes these to suppress production behaviour in dev.
// LEVEL_WON, LEVEL_LOST, RESTART_GAME – changed from emit → dispatch at emission sites.

export const GameEvents = {
  // -- dispatched lifecycle --
  LEVEL_WON: 'levelWon',
  LEVEL_LOST: 'levelLost',
  RESTART_GAME: 'restart-game',

  // -- screen / navigation --
  SET_SCREEN: 'setScreen',
  PLAY_LEVEL: 'playLevel',
  PLAY_LEVEL_FROM_DATA: 'playLevelFromData',
  LEVEL_PREPARED: 'levelPrepared',
  LEVEL_STARTED: 'levelStarted',
  REPLAY_CURRENT_LEVEL: 'replayCurrentLevel',
  CONTINUE_TO_NEXT_LEVEL: 'continueToNextLevel',
  RETURN_TO_HOME: 'return-to-home',
  CONTINUE_CAMPAIGN: 'continue-campaign',
  START_SANDBOX: 'start-sandbox',

  // -- progress / tutorial --
  CLEAR_PROGRESS: 'clearProgress',
  SET_TUTORIAL_SHOWN: 'setTutorialShown',
  RESET_PROGRESS: 'reset-progress',
  DISMISS_TUTORIAL: 'dismiss-tutorial',
  SHOW_TUTORIAL: 'show-tutorial',
  SET_VISION_VIEWED: 'setVisionViewed',
  SHOW_VISION: 'showVision',
  CLAIM_REWARD: 'claimReward',

  // -- input / action modes --
  ACTION_MODE_CHANGED: 'actionModeChanged',
  ACTION_MODES_UPDATED: 'actionModesUpdated',
  PLAYER_ACTION_TAKEN: 'playerActionTaken',
  PLAYER_ACTION_REQUESTED: 'playerActionRequested',
  RECORD_PLAYER_ACTION: 'recordPlayerAction',
  SET_ACTION_MODE: 'setActionMode',

  // -- rendering / spatial --
  UPDATE_TERRAIN: 'updateTerrain',
  UPDATE_CHARACTERS: 'updateCharacters',
  START_ANIMATIONS: 'startAnimations',
  ANIMATIONS_COMPLETE: 'animationsComplete',
  UPDATE_PLAYER_ACTION_HIGHLIGHTS: 'updatePlayerActionHighlights',
  CLEAR_PLAYER_ACTION_HIGHLIGHTS: 'clearPlayerActionHighlights',
  UPDATE_ENEMY_PATTERN_HIGHLIGHTS: 'updateEnemyPatternHighlights',
  CLEAR_ENEMY_PATTERN_HIGHLIGHTS: 'clearEnemyPatternHighlights',
  UPDATE_INTENTION_INDICATORS: 'updateIntentionIndicators',
  CLEAR_INTENTION_INDICATORS: 'clearIntentionIndicators',

  // -- level lifecycle --
  PHASER_CANVAS_READY: 'phaserCanvasReady',
  PHASER_CANVAS_DESTROYED: 'phaserCanvasDestroyed',
  PREPARE_SCENE: 'prepareScene',  // LevelHandler → SpatialHandler: create/start scene
  LEVEL_STARTED: 'levelStarted',

  // -- scene input events --
  PLAYER_TAPPED_HEX: 'playerTappedHex',
  CAMERA_ZOOM_REQUESTED: 'cameraZoomRequested',
  CAMERA_PAN_REQUESTED: 'cameraPanRequested',

  // -- examine --
  ENEMY_EXAMINED: 'enemyExamined',
  ENEMY_EXAMINE_DISMISSED: 'enemyExamineDismissed',
  ENEMY_STAT_SHEET_TOGGLED: 'enemyStatSheetToggled',

  // -- undo --
  UNDO_LAST_MOVE: 'undoLastMove',
  MOVE_COUNT_UPDATED: 'moveCountUpdated',

  // -- solution replay (production) --
  START_SOLUTION_REPLAY: 'startSolutionReplay',
  EXIT_SOLUTION_REPLAY: 'exitSolutionReplay',
  SOLUTION_REPLAY_STEP_FORWARD: 'solutionReplayStepForward',
  SOLUTION_REPLAY_STEP_BACKWARD: 'solutionReplayStepBackward',
  REPLAY_SOLUTION_ACTION: 'replaySolutionAction', // Relative action that needs conversion

  // -- dev: solution replay --
  SOLUTIONS_LOADED: 'solutionsLoaded',
  SELECT_SOLUTION: 'selectSolution',
  PLAY_NEXT_SOLUTION_STEP: 'playNextSolutionStep',

  // -- dev: curation --
  PLAY_CANDIDATE: 'playCandidate',
  CURATION_NEXT_CANDIDATE: 'curationNextCandidate',
  EXIT_CURATION: 'exitCuration',
  CURATION_SAVED: 'curationSaved',
};
